import {takeLatest, takeLeading} from 'redux-saga/effects';

import {getAdminDashboardDataACS, getManagerDashboardDataACS} from './appSlice';
import {getAdminDashboardCount, getManagerDashboardData} from './dashboardData/saga';
import {
  getUserACS,
  changePasswordACS,
  loginUserACS,
  registerUserACS,
  resetPasswordACS,
  updateUserACS,
} from './requestAC';
import {changePassword, getUser, loginUser, registerUser, resetPassword, updateUser} from './user/saga';

export default function* appSaga() {
  yield takeLatest(loginUserACS.type, loginUser);
  yield takeLatest(registerUserACS.type, registerUser);
  yield takeLatest(resetPasswordACS.type, resetPassword);
  yield takeLatest(changePasswordACS.type, changePassword);
  yield takeLatest(getAdminDashboardDataACS.type, getAdminDashboardCount);
  yield takeLatest(getManagerDashboardDataACS.type, getManagerDashboardData);
  yield takeLeading(getUserACS.type, getUser);
  yield takeLatest(updateUserACS, updateUser);
}
